import {
  getChildDetailsQueryParams,
  getCoverageQueryParam,
} from "Components/Features/CheckPrice/checkPriceQueryParamUtils";

import { ChildCoverageQueryParam } from "Components/Features/CheckPrice/checkPriceTypes";
import { ChildCoverage } from "Store/interfaces/products/coverage";
import { isDefined } from "Utils/functions";

export function defaultCoverage(): ChildCoverage | undefined {
  const childIndex = getChildDetailsQueryParams().childIndex;
  const coverage = getCoverageQueryParam();

  if (isDefined(childIndex)) {
    return undefined;
  }

  switch (coverage) {
    case ChildCoverageQueryParam.BASIC:
      return ChildCoverage.BASIC;
    case ChildCoverageQueryParam.EXTRA:
      return ChildCoverage.EXTRA;
    case ChildCoverageQueryParam.TOTAL:
      return ChildCoverage.TOTAL;
    default:
      return undefined;
  }
}
